// Small localStorage-backed store for the last 3 packages the visitor peeked at.
const KEY = "rx_recent_views";
const MAX = 3;

export function pushRecent(entry) {
  // entry: { vertical, lookup_key, name, amount, region, ts? }
  if (!entry?.lookup_key || !entry?.vertical) return;
  const now = Date.now();
  const existing = getRecent().filter(e => e.lookup_key !== entry.lookup_key);
  const next = [{ ...entry, ts: now }, ...existing].slice(0, MAX);
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // ignore
  }
}

export function getRecent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}
